
import React from 'react';
import { motion } from 'framer-motion';
import { Users, Heart, Lightbulb, Award, Users2 } from 'lucide-react';

const AboutPage = () => {
  const fadeIn = (delay = 0, y = 20) => ({
    hidden: { opacity: 0, y: y, scale: 0.98 },
    visible: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.7, delay, ease: [0.6, -0.05, 0.01, 0.99] } },
  });

  return (
    <div className="container mx-auto px-4 section-padding overflow-hidden">
      <motion.div
        initial="hidden"
        animate="visible"
        className="max-w-4xl mx-auto text-center"
      >
        <motion.h1
          variants={fadeIn(0.2, 30)}
          className="page-title mt-8"
        >
          Wij geloven dat ieder kind iemand nodig heeft die <span className="text-cm-blue-dark font-medium">écht luistert.</span>
        </motion.h1>
        <motion.p
          variants={fadeIn(0.4, 20)}
          className="page-subtitle leading-relaxed"
        >
          Gedreven door <strong className="font-semibold">passie</strong> en <strong className="font-semibold">expertise</strong>, bouwen wij aan Classbuddy. Een team van leerkrachten, pedagogen, tech-enthousiastelingen en ouders, verenigd in de missie om een veilige haven te creëren waar kinderen kunnen praten, leren en groeien. Zonder oordeel, zonder druk, met oneindig geduld.
        </motion.p>

        <motion.div 
          variants={fadeIn(0.6, 20)}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 text-left mt-16"
        >
          <ValueCard
            icon={<Heart size={36} className="text-cm-pink" />}
            title="Onze Kern: Empathie"
            description="We benaderen de wereld van kinderen met diep begrip, zorg en compassie. Elk kind telt."
            delay={0.7}
          />
          <ValueCard
            icon={<Lightbulb size={36} className="text-cm-yellow" />}
            title="Kracht van Innovatie"
            description="Met slimme technologie maken we effectieve en toegankelijke ondersteuning voor iedereen mogelijk."
            delay={0.8}
          />
          <ValueCard
            icon={<Users2 size={36} className="text-cm-green" />}
            title="Samen Sterker"
            description="Door nauwe samenwerking met scholen, experts en kinderen zelf, bouwen we de beste ervaring."
            delay={0.9}
          />
        </motion.div>

        <motion.div variants={fadeIn(1.0, 20)} initial="hidden" animate="visible" className="mt-20 p-10 glassmorphism-card rounded-2xl">
           <Award size={48} className="text-cm-blue mx-auto mb-6" />
          <h2 className="text-3xl font-heading font-medium text-cm-blue-dark mb-4">Onze Missie</h2>
          <p className="text-lg text-cm-gray max-w-2xl mx-auto leading-relaxed">
            Het is onze missie om elk kind te voorzien van een laagdrempelige, veilige en anonieme gesprekspartner. Een buddy die altijd klaarstaat om te luisteren, te helpen en te ondersteunen in hun sociaal-emotionele ontwikkeling. We streven naar een wereld waarin geen enkel kind zich alleen voelt met zijn of haar zorgen.
          </p>
        </motion.div>

      </motion.div>
    </div>
  );
};

const ValueCard = ({ icon, title, description, delay }) => {
  const fadeIn = (delay = 0, y = 20) => ({ 
    hidden: { opacity: 0, y: y, scale: 0.98 },
    visible: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.7, delay, ease: [0.6, -0.05, 0.01, 0.99] } },
  });

  return (
    <motion.div 
      variants={fadeIn(delay, 15)}
      initial="hidden"
      animate="visible"
      className="glassmorphism-card p-8 rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 flex flex-col h-full"
      whileHover={{ y: -8, scale: 1.02 }}
    >
      <div className="flex items-center mb-5">
        <div className="flex-shrink-0 w-16 h-16 bg-gradient-to-br from-cm-blue-light to-white rounded-full flex items-center justify-center shadow-md mr-4">
          {icon}
        </div>
        <h3 className="text-2xl font-heading font-medium text-cm-blue-dark">{title}</h3>
      </div>
      <p className="text-cm-gray text-md leading-relaxed flex-grow">{description}</p>
    </motion.div>
  );
};

export default AboutPage;
